import { render, staticRenderFns } from "./trainingsHubWorkoutTimeline.vue?vue&type=template&id=2643f6fb&scoped=true"
import script from "./trainingsHubWorkoutTimeline.vue?vue&type=script&lang=js"
export * from "./trainingsHubWorkoutTimeline.vue?vue&type=script&lang=js"
import style0 from "./trainingsHubWorkoutTimeline.vue?vue&type=style&index=0&id=2643f6fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2643f6fb",
  null
  
)

export default component.exports